import Layout from '../../layouts/Layout';
import { Loading } from '../../pages/Game/screens/Loading';

const LoadingScreen = () => {
  return (
    <Layout>
      <Loading />
    </Layout>
  );
};

export default LoadingScreen;
